const btnDisplayMenu = document.querySelector(`.nav__menu`).children[0];
const btnDescriptions = document.querySelectorAll(`.description`);
const containerDescription = document.querySelector(
  `.portfolio__article__footer__description`
);
const ownerLink = document.querySelector(`.owner__doc`);
const tabscontainer = document.querySelector(`.nav__links`);
const menuTab = document.querySelector(`.modal__link`);
const tabs = document.querySelectorAll(`.operation__tab`);
const sections = document.querySelectorAll(`.operation__content`);
const btnCloseMenu = document.querySelector(`.btn--close-modal`);
const menu = document.querySelector(`.modal`);
const sectionsDiv = document.querySelector(`.sections__container`);
const overlay = document.querySelector(`.overlay`);

//implementing open and close menu
const menuDisplay = function (e) {
  e.preventDefault();
  [overlay, menu].forEach(btn => {
    btn.classList.remove(`hidden`);
    btn.classList.add(`animate__fadeInLeft`);
  });
};

const menuClose = function () {
  menu.classList.add(`hidden`);
  overlay.classList.add(`hidden`);
};

btnDisplayMenu.addEventListener(`click`, menuDisplay);

[overlay, btnCloseMenu].forEach(btn => {
  btn.addEventListener(`click`, menuClose);
});

document.addEventListener(`keydown`, function (e) {
  if (e.key === `Escape` && !menu.classList.contains(`hidden`)) {
    menuClose();
  }
});

// implementing open and close description

btnDescriptions.forEach(btn =>
  btn.addEventListener(`click`, function (e) {
    this.classList.toggle(`description--expanded`);
  })
);

//implementing navigation through sections

[ownerLink, tabscontainer, menuTab].forEach(tab =>
  tab.addEventListener(`click`, function (e) {
    //getting the buttons through event delegation
    const clicked = e.target.closest(`.operation__tab`);
    console.log(clicked);
    //gaurd clause
    if (!clicked) return;

    //identifying the button
    //if (clicked.parentElement.classList.includes(`modal__links`)) {
    //} else {
    sections.forEach(sec => sec.classList.remove(`operation__content--active`));

    tabs.forEach(t => t.classList.remove(`operation__tab--active`));

    clicked.parentElement.parentElement.classList.contains(`modal__link`)
      ? ``
      : clicked.classList.add(`operation__tab--active`);

    if (clicked.classList.contains(`owner__link`)) {
      const tabsArr = Array.from(tabs);
      tabsArr
        .find(t => t.classList.contains(`operation__tab--3`))
        .classList.add(`operation__tab--active`);
    }
    menuClose();
    //}

    //linking the link button to its section
    console.log(tabs);
    document
      .querySelector(`.operation__content--${clicked.dataset.tab}`)
      .classList.add(`operation__content--active`);
  })
);

//implementing the load event

[`hashchange`, `load`].forEach(evt => {
  window.addEventListener(evt, function () {
    tabs.forEach(t => t.classList.remove(`operation__tab--active`));

    const hash = window.location.hash.slice(1);

    //gaurd clause
    sectionsDiv.classList.remove(`tag`);

    if (!hash) {
      sections.forEach(sec =>
        sec.classList.remove(`operation__content--active`)
      );
      document
        .getElementById(`home`)
        .classList.add(`operation__content--active`);
      return;
    }

    const tabsarr = Array.from(tabs);
    tabsarr
      .find(t => t.dataset.name === hash)
      .classList.add(`operation__tab--active`);
    //linking the hashchange to the tab

    sections.forEach(sec => sec.classList.remove(`operation__content--active`));
    document
      .getElementById(`${hash}`)
      .classList.add(`operation__content--active`);
  });
});
